import React, { useState } from 'react';
import {
  TableContainer, Table, TableHead, TableBody,
  TableRow, TableCell, Paper, TextField
} from '@mui/material';

const EditableTable = ({ initialRows, onRowsChange }) => {
  const [rows, setRows] = useState(initialRows);

  const handleCellChange = (rowIndex, cellIndex, value) => {
    const updatedRows = [...rows];
    updatedRows[rowIndex][cellIndex] = value;
    setRows(updatedRows);
    onRowsChange(updatedRows); 
  };

  return (
    <TableContainer component={Paper} sx={{ mt: 2, mb: 2 }}>
      <Table size="small">
        <TableHead>
          <TableRow sx={{ backgroundColor: '#e3f2fd' }}>
            {rows[0].map((header, i) => (
              <TableCell key={i} sx={{ color: '#1976d2', fontWeight: 'bold' }}>
                {header}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.slice(1).map((row, rowIndex) => (
            <TableRow key={rowIndex}>
              {row.map((cell, cellIndex) => (
                <TableCell key={cellIndex}>
                  <TextField
                    variant="standard"
                    value={cell}
                    onChange={(e) =>
                      handleCellChange(rowIndex + 1, cellIndex, e.target.value)
                    }
                    fullWidth
                    inputProps={{ style: { fontSize: '14px' } }}
                  />
                </TableCell>
              ))}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default EditableTable;
